import { ChatBotUIInfoMessage } from "@jugl-web/domain-resources/chat-bot/types";
import { forwardRef } from "react";

export interface ChatBotInfoMessageComponentProps {
  message: ChatBotUIInfoMessage;
}

export const ChatBotInfoMessageComponent = forwardRef<
  HTMLDivElement,
  ChatBotInfoMessageComponentProps
>(({ message }, ref) => {
  return (
    <div ref={ref} className="flex items-center justify-center px-2 py-5">
      <div className="rounded-3xl bg-grey-100 px-[14px] py-1.5 text-center">
        <span className="inline-block font-secondary text-[13px] leading-[160%] font-normal text-dark-800">
          ⚡ {message.text}
        </span>
      </div>
    </div>
  );
});

ChatBotInfoMessageComponent.displayName = "ChatBotInfoMessageComponent";
